<template>
  <div class="content">
    <h1 class="content__title" v-text="texts.title"></h1>
    <span class="content__details" v-text="texts.subtitle"></span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Datos de la Entrada</h2>

          <div class="waiting" v-if="loading">
            <img src="/static/img/waiting.gif" alt="Cargando Información" class="waiting__image">
          </div>

          <form class="form" @submit.prevent="savePost" v-if="!loading">
            <div class="form__fielset">

              <div class="form__container form__container--half">
                <label for="title_es" class="form__label form__label--required">Título de la Entrada (Español)</label>
                <input type="text" class="form__input" name="title_es" id="title_es" placeholder="Título de la entrada (Español)" v-model="entry.title_es" v-validate="validation.title_es">
                <span v-show="errors.has('title_es')" class="form__alert">{{ errors.first('title_es') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="title_en" class="form__label form__label--required">Título de la Entrada (Inglés)</label>
                <input type="text" class="form__input" name="title_en" id="title_en" placeholder="Título de la entrada (Inglés)" v-model="entry.title_en" v-validate="validation.title_en">
                <span v-show="errors.has('title_en')" class="form__alert">{{ errors.first('title_en') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="title_fr" class="form__label form__label--required">Título de la Entrada (Francés)</label>
                <input type="text" class="form__input" name="title_fr" id="title_fr" placeholder="Título de la entrada (Francés)" v-model="entry.title_fr" v-validate="validation.title_fr">
                <span v-show="errors.has('title_fr')" class="form__alert">{{ errors.first('title_fr') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="title_it" class="form__label form__label--required">Título de la Entrada (Italiano)</label>
                <input type="text" class="form__input" name="title_it" id="title_it" placeholder="Título de la entrada (Italiano)" v-model="entry.title_it" v-validate="validation.title_it">
                <span v-show="errors.has('title_it')" class="form__alert">{{ errors.first('title_it') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="title_pt" class="form__label form__label--required">Título de la Entrada (Portugés)</label>
                <input type="text" class="form__input" name="title_pt" id="title_pt" placeholder="Título de la entrada (Portugés)" v-model="entry.title_pt" v-validate="validation.title_pt">
                <span v-show="errors.has('title_pt')" class="form__alert">{{ errors.first('title_pt') }}</span>
              </div>

							<div class="form__container form__container--half">
                <label for="title_de" class="form__label form__label--required">Título de la Entrada (Alemán)</label>
                <input type="text" class="form__input" name="title_de" id="title_de" placeholder="Título de la entrada (Alemán)" v-model="entry.title_de" v-validate="validation.title_de">
                <span v-show="errors.has('title_de')" class="form__alert">{{ errors.first('title_de') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="excerpt_es" class="form__label">Resumen (Español)</label>
                <textarea class="form__input" name="excerpt_es" id="excerpt_es" placeholder="Resumen (Español)" v-model="entry.excerpt_es" v-validate="validation.excerpt_es"></textarea>
                <span v-show="errors.has('excerpt_es')" class="form__alert">{{ errors.first('excerpt_es') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="excerpt_en" class="form__label">Resumen (Inglés)</label>
                <textarea class="form__input" name="excerpt_en" id="excerpt_en" placeholder="Resumen (Inglés)" v-model="entry.excerpt_en" v-validate="validation.excerpt_en"></textarea>
                <span v-show="errors.has('excerpt_en')" class="form__alert">{{ errors.first('excerpt_en') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="excerpt_fr" class="form__label">Resumen (Francés)</label>
                <textarea class="form__input" name="excerpt_fr" id="excerpt_fr" placeholder="Resumen (Francés)" v-model="entry.excerpt_fr" v-validate="validation.excerpt_fr"></textarea>
                <span v-show="errors.has('excerpt_fr')" class="form__alert">{{ errors.first('excerpt_fr') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="excerpt_it" class="form__label">Resumen (Italiano)</label>
                <textarea class="form__input" name="excerpt_it" id="excerpt_it" placeholder="Resumen (Italiano)" v-model="entry.excerpt_it" v-validate="validation.excerpt_it"></textarea>
                <span v-show="errors.has('excerpt_it')" class="form__alert">{{ errors.first('excerpt_it') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="excerpt_pt" class="form__label">Resumen (Portugés)</label>
                <textarea class="form__input" name="excerpt_pt" id="excerpt_pt" placeholder="Resumen (Portugés)" v-model="entry.excerpt_pt" v-validate="validation.excerpt_pt"></textarea>
                <span v-show="errors.has('excerpt_pt')" class="form__alert">{{ errors.first('excerpt_pt') }}</span>
              </div>

							<div class="form__container form__container--half">
                <label for="excerpt_de" class="form__label">Resumen (Alemán)</label>
                <textarea class="form__input" name="excerpt_de" id="excerpt_de" placeholder="Resumen (Alemán)" v-model="entry.excerpt_de" v-validate="validation.excerpt_de"></textarea>
                <span v-show="errors.has('excerpt_de')" class="form__alert">{{ errors.first('excerpt_de') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="content_es" class="form__label">Contenido (Español)</label>
                <ckeditor-component :className="'form__input'" v-model="entry.content_es" v-validate="validation.content_es" name="content_es" id="content_es"></ckeditor-component>
                <span v-show="errors.has('content_es')" class="form__alert">{{ errors.first('content_es') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="content_en" class="form__label">Contenido (Inglés)</label>
                <ckeditor-component :className="'form__input'" v-model="entry.content_en" v-validate="validation.content_en" name="content_en" id="content_en"></ckeditor-component>
                <span v-show="errors.has('content_en')" class="form__alert">{{ errors.first('content_en') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="content_fr" class="form__label">Contenido (Francés)</label>
                <ckeditor-component :className="'form__input'" v-model="entry.content_fr" v-validate="validation.content_fr" name="content_fr" id="content_fr"></ckeditor-component>
                <span v-show="errors.has('content_fr')" class="form__alert">{{ errors.first('content_fr') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="content_it" class="form__label">Contenido (Italiano)</label>
                <ckeditor-component :className="'form__input'" v-model="entry.content_it" v-validate="validation.content_it" name="content_it" id="content_it"></ckeditor-component>
                <span v-show="errors.has('content_it')" class="form__alert">{{ errors.first('content_it') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="content_pt" class="form__label">Contenido (Portugés)</label>
                <ckeditor-component :className="'form__input'" v-model="entry.content_pt" v-validate="validation.content_pt" name="content_pt" id="content_pt"></ckeditor-component>
                <span v-show="errors.has('content_pt')" class="form__alert">{{ errors.first('content_pt') }}</span>
              </div>
							
							<div class="form__container form__container--half">
                <label for="content_de" class="form__label">Contenido (Alemán)</label>
                <ckeditor-component :className="'form__input'" v-model="entry.content_de" v-validate="validation.content_de" name="content_de" id="content_de"></ckeditor-component>
                <span v-show="errors.has('content_de')" class="form__alert">{{ errors.first('content_de') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="tags_es" class="form__label">Etiquetas (Español)</label>
                <textarea class="form__input" name="tags_es" id="tags_es" placeholder="Etiquetas (Español)" v-model="tags.es" v-validate="validation.tags_es"></textarea>
                <span v-show="errors.has('tags_es')" class="form__alert">{{ errors.first('tags_es') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="tags_en" class="form__label">Etiquetas (Inglés)</label>
                <textarea class="form__input" name="tags_en" id="tags_en" placeholder="Etiquetas (Inglés)" v-model="tags.en" v-validate="validation.tags_en"></textarea>
                <span v-show="errors.has('tags_en')" class="form__alert">{{ errors.first('tags_en') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="tags_fr" class="form__label">Etiquetas (Francés)</label>
                <textarea class="form__input" name="tags_fr" id="tags_fr" placeholder="Etiquetas (Francés)" v-model="tags.fr" v-validate="validation.tags_fr"></textarea>
                <span v-show="errors.has('tags_fr')" class="form__alert">{{ errors.first('tags_fr') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="tags_it" class="form__label">Etiquetas (Italiano)</label>
                <textarea class="form__input" name="tags_it" id="tags_it" placeholder="Etiquetas (Italiano)" v-model="tags.it" v-validate="validation.tags_it"></textarea>
                <span v-show="errors.has('tags_it')" class="form__alert">{{ errors.first('tags_it') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="tags_pt" class="form__label">Etiquetas (Portugés)</label>
                <textarea class="form__input" name="tags_pt" id="tags_pt" placeholder="Etiquetas (Portugés)" v-model="tags.pt" v-validate="validation.tags_pt"></textarea>
                <span v-show="errors.has('tags_pt')" class="form__alert">{{ errors.first('tags_pt') }}</span>
              </div>

							<div class="form__container form__container--half">
                <label for="tags_de" class="form__label">Etiquetas (Alemán)</label>
                <textarea class="form__input" name="tags_de" id="tags_de" placeholder="Etiquetas (Alemán)" v-model="tags.de" v-validate="validation.tags_de"></textarea>
                <span v-show="errors.has('tags_de')" class="form__alert">{{ errors.first('tags_de') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="status_id" class="form__label form__label--required">Estatus</label>
                <div class="form__select-container">
                  <select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="entry.status_id">
                    <option :value="null">Seleccionar Estatus</option>
                    <option v-for="(status, index) in statusList" :key="index" :value="status.id" v-text="status.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('status_id')" class="form__alert">{{ errors.first('status_id') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="cover" class="form__label">Cover</label>
                <input-viewer name="cover" v-model="entry.cover" v-validate="validation.cover"></input-viewer>
                <span v-show="errors.has('cover')" class="form__alert">{{ errors.first('cover') }}</span>
              </div>

              <input type="submit" class="btn btn__default btn--regular" :value="texts.submit">

            </div>
          </form>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'postList', params: {page: 1}}">Páginas</router-link>
        <router-link v-if="$route.name === 'pageEdit'" class="btn btn--small btn__default" :to="{name: 'pageNew'}">Nueva Página</router-link>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from '@/api/request'
import { validation, Fields, StatusList, texts } from './moks'
import inputViewer from '@/components/media/input'
import { stringToJson } from '@/assets/js/libs/functions'
import ckeditorComponent from '@/helpers/ckeditor/editor'

export default {
	mixins: [httpService],
	components: {
		inputViewer,
		ckeditorComponent
	},
	data: function() {
		return {
			validation: validation,
			entry: null,
			tags: {
				es: null,
				en: null,
				fr: null,
				it: null,
				pt: null,
				de: null
			},
			statusList: StatusList
		}
	},
	created: function() {
		this.start()
	},
	watch: {
		'$route.path': function() {
			this.start()
		}
	},
	methods: {
		start: function() {
			if (this.pageId) {
				this.getPost()
			} else {
				this.entry = new Fields()
				this.tags = {
					es: null,
					en: null,
					fr: null,
					it: null,
					pt: null,
					de: null
				}
			}
		},
		getPost: function() {
			let httpRequest = {
				params: '',
				module: 'pages'
			}
			this.getById(this.pageId, httpRequest)
				.then(entry => {
					this.entry = entry.data
					if (entry.data.cover) {
						this.entry.cover = JSON.parse(entry.data.cover)
					}
					if (entry.data.tags_es) {
						let tags_es = JSON.parse(entry.data.tags_es)
						this.tags.es = tags_es.reduce((string, element) => string + ',' + element)
					}
					if (entry.data.tags_en) {
						let tags_en = JSON.parse(entry.data.tags_en)
						this.tags.en = tags_en.reduce((string, element) => string + ',' + element)
					}
					if (entry.data.tags_fr) {
						let tags_fr = JSON.parse(entry.data.tags_fr)
						this.tags.fr = tags_fr.reduce((string, element) => string + ',' + element)
					}
					if (entry.data.tags_it) {
						let tags_it = JSON.parse(entry.data.tags_it)
						this.tags.it = tags_it.reduce((string, element) => string + ',' + element)
					}
					if (entry.data.tags_pt) {
						let tags_pt = JSON.parse(entry.data.tags_pt)
						this.tags.pt = tags_pt.reduce((string, element) => string + ',' + element)
					}
					if (entry.data.tags_de) {
						let tags_de = JSON.parse(entry.data.tags_de)
						this.tags.de = tags_de.reduce((string, element) => string + ',' + element)
					}

				})
				.catch(() => {
					this.$router.push({ name: 'pageNew' })
				})
		},
		savePost: function() {
			for (const key in this.tags) {
				if (this.tags[key]) {
					this.entry['tags_' + key] = stringToJson(this.tags[key])
				}
			}
			this.$validator.validateAll().then(response => {
				if (response) {
					let httpRequest = {
						params: '',
						module: 'pages',
						element: this.entry
					}
					let request
					if (this.$route.name === 'pageEdit') {
						request = this.put(this.pageId, httpRequest)
					} else if (this.$route.name === 'pageNew') {
						request = this.post(httpRequest)
					}
					request.then(response => {
						this.$store.commit('notificate', {
							title: this.texts.messages.success.title,
							text: this.texts.messages.success.text,
							type: 'success'
						})
						if (this.$route.name === 'pageNew') {
							this.$router.push({ name: 'pageEdit', params: { id: response.data.current_id } })
						}
					})
				} else {
					this.$store.commit('notificate', {
						title: 'CAMPOS REQUERIDOS',
						text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
						type: 'warn'
					})
				}
			})
		}
	},
	computed: {
		pageId: function() {
			return this.$route.params.id
		},
		loading: function() {
			return this.$route.params.id && !this.entry
		},
		texts: function() {
			return texts[this.$route.name]
		}
	}
}
</script>

<style lang="sass">
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/pages/edit.vue